import { FC } from 'react';
import { Box, Stack, Button, Link, Typography } from '@mui/material';
import { AccountPhoto } from '@barracuda/shared/components/AccountPhoto/AccountPhoto';
import {
  hamburgerMenuStyle,
  logoLink,
  logOutStyle,
  navbar,
  navbarDesktop,
  navbarList,
  navbarListRight,
  signInButtonNavbar,
  signInUpButtonsContainer,
  signUpButtonNavbar
} from './HeaderNavbar.style';
import Logo from '@/assets/images/pearson-logo-odyssey.svg';
import { useLocation } from 'react-router-dom';
import { Auth } from '@barracuda/shared';
import { useAppContext } from '@/context/App.context';
import HamburgerMenu from '@/assets/images/hamburger-menu.svg';
import { useLocalizedNavigate } from '@/hooks/useLocalizedNavigate';
import { useTranslation } from 'react-i18next';
import Img from '@barracuda/shared/components/Primitive/Img';
import { mixpanelApi } from '@barracuda/shared/analytics/mixpanel';
import useGenerateLinks from './useGenerateLinks';
import { renderDesktopItems } from '../NavbarMenuItem/navbarMenu.utils';
import { useSetIsMenuOpen } from '@/store/useAppStore';

export const HeaderNavbar: FC<{ code?: string }> = () => {
  const { isLoggedIn, user, setUser, setIsLoggedIn } = useAppContext();
  const { pathname } = useLocation();
  const { t } = useTranslation();
  const navigate = useLocalizedNavigate();
  const setIsMenuOpen = useSetIsMenuOpen();

  const logout = () => {
    mixpanelApi.onLogout();

    Auth.logout(user?.profile?.loggedBefore);
    setUser(undefined);
    setIsLoggedIn(false);
    navigate('/login');
  };

  const { links } = useGenerateLinks({ isLoggedIn, user });

  const handleSignUp = () => {
    navigate('/join');
  };

  const handleSignIn = () => {
    navigate('/login');
  };

  const handleAccountRedirect = () => {
    navigate('../login?redirectUrl=/dashboard/account');
  };

  return (
    <Box sx={navbar}>
      <Box sx={navbarDesktop}>
        <Link onClick={() => navigate(isLoggedIn ? '/dashboard' : '')} sx={logoLink}>
          <Img src={Logo} alt='PTE Express logo' />
        </Link>
        <Box component='ul' sx={navbarList}>
          {isLoggedIn ? links : renderDesktopItems()}
        </Box>
        {isLoggedIn && (
          <>
            <Box component='ul' sx={{ ...navbarList, ...navbarListRight }}>
              <AccountPhoto
                handlePhotoClick={handleAccountRedirect}
                imageUri={user?.imageUri}
                width='42px'
                height='42px'
              />
              <Typography component='div' sx={logOutStyle} onClick={logout}>
                {t('menuLabels.logOut')}
              </Typography>
            </Box>
            <Button sx={hamburgerMenuStyle} onClick={() => setIsMenuOpen?.(true)}>
              <Img src={HamburgerMenu} alt='Menu' />
            </Button>
          </>
        )}
      </Box>
      {!isLoggedIn && (
        <Stack sx={signInUpButtonsContainer}>
          <Button sx={signUpButtonNavbar} onClick={handleSignUp} id='header-sign-up'>
            <Box display='flex' gap='8px' alignItems='center'>
              <Box>{t('signUpText')}</Box>
            </Box>
          </Button>
          <Button size='large' sx={signInButtonNavbar} onClick={handleSignIn} id='header-sign-in'>
            {t('loginInText')}
          </Button>
        </Stack>
      )}
      {!isLoggedIn && !pathname.includes('verification') && (
        <Button sx={hamburgerMenuStyle} onClick={() => setIsMenuOpen?.(true)}>
          <Img src={HamburgerMenu} alt='Menu' />
        </Button>
      )}
    </Box>
  );
};
